/**************************************************
 * Nombre:       Formulario_Zona_Produccion
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {CoffeeMakerOutlined, Flag, UpgradeOutlined, TableRestaurantOutlined} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {ESTADOSMESASCONFIG} from "../../Constantes";

const Formulario_Zona_Produccion = ({...props}) => {



    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >




                <Grid container size={12}>
                    <IngresoTexto Icono={CoffeeMakerOutlined} nombre={'Nombre de Zona'} dato={'nombre'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>






            </Grid>

        </form>

    )

}
export default Formulario_Zona_Produccion